var _rect, _g, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-225 -114 450 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag of Malawi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -225,
    y: -114,
    width: 450,
    height: 300
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#CE1126"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 64.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -225,
    y: -14,
    width: 450,
    height: 100
  }), /*#__PURE__*/React.createElement("g", {
    id: "r16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "r8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "r4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "r2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "r",
    d: "M0-102c-2.2,0-3,3.3-3,6.5 0,8 1,12 3,23.5 2.04-11.5 3-15.6 3-23.5 0-3.3-1-6.5-3-6.5"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(5)",
    xlinkHref: "#r"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(10)",
    xlinkHref: "#r2"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(20)",
    xlinkHref: "#r4"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(40)",
    xlinkHref: "#r8"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-80)",
    xlinkHref: "#r16"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -225,
    y: -21.5,
    width: 450,
    height: 7.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -225,
    y: 86,
    width: 450,
    height: 100,
    fill: "#339E35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMw);
export default __webpack_public_path__ + "static/media/mw.33e950c65f58447f1b81e38f741517d0.svg";
export { ForwardRef as ReactComponent };